import { createStore } from 'zustand/vanilla';

import type { BootstrapResponse, MenuNode, SessionResponse } from './types';

export type SessionStatus = 'unknown' | 'authenticated' | 'anonymous';

export interface SessionState {
	status: SessionStatus;
	session: SessionResponse | null;
	menus: MenuNode[];
	setBootstrap: (bootstrap: BootstrapResponse) => void;
	setAnonymous: () => void;
}

/** MF 싱글톤으로 셸·리모트가 같은 인스턴스를 구독한다 (React 바인딩은 zustand useStore) */
export const sessionStore = createStore<SessionState>((set) => ({
	status: 'unknown',
	session: null,
	menus: [],
	setBootstrap: (bootstrap) => set({ status: 'authenticated', session: bootstrap.session, menus: bootstrap.menus }),
	setAnonymous: () => set({ status: 'anonymous', session: null, menus: [] }),
}));
